export enum DashboardType {
    MarketDashboard = 'market-dashboard',
    AdvertiserDashboard = 'advertiser-dashboard',
    PlannerDashboard = 'planner-dashboard'
}

export enum AdvertiserDashboardPage {
    Plans = 'planner-list',
    Deals = 'deal-list'
}